import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';

const ContactUs = () => {
  const { t } = useTranslation(); 
  const [selectedLocation, setSelectedLocation] = useState('default');

  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;

    const formData = new FormData(form);

    try {
      const response = await fetch("https://formspree.io/f/mnnpnejd", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      if (response.ok) {
        Swal.fire({
          title: t('contactus.successMessage'),
          text: t('contactus.thankYouMessage'),
          icon: "success",
        });
        form.reset(); // Clear the form fields
        setSelectedLocation('default'); // Reset location
      } else {
        throw new Error("Form submission failed");
      }
    } catch (error) {
      Swal.fire({
        title: t('contactus.errorMessage'),
        text: t('contactus.tryAgainMessage'),
        icon: "error",
      });
    }
  };

  const getMapSrc = () => {
    if (selectedLocation === 'Tabanovce') {
      return "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1477.1023635008953!2d21.703232060675052!3d42.23143901765084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13545725685665cd%3A0xb8d568951ea00224!2sBorder%20Crossing%20Tabanovtse%2C%20E75!5e0!3m2!1sen!2smk!4v1734054882092!5m2!1sen!2smk";
    }
    return "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2934.0415164735435!2d21.459340115660873!3d41.99883767921468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13541547e033f407%3A0xf50d4885a0a7ae4f!2sSimax!5e0!3m2!1sen!2smk!4v1702217128115!5m2!1sen!2smk";
  };

  return (
    <div className="mx-auto px-5 max-w-[1290px] mb-20 w-full lg:mt-20 mt-10 py-12 grid grid-cols-1 md:grid-cols-2 gap-[64px]">
      <div className="md:justify-self-start lg:w-[120%]">
        <h1 className="lg:text-[47.78px] text-[33.18px] leading-[39.82px] lg:leading-[57.34px] font-[900] mb-6">{t('contactus.title')}</h1>
        <p className="lg:text-[19.2px] text-[16px] lg:leading-[24.96px] leading-[20.8px] font-[400] text-[#3D3D3D] mb-28">
          {t('contactus.description')}
        </p>

        <form className="space-y-6" onSubmit={handleSubmit}>
          <div>
            <label
              htmlFor="location"
              className="block text-[13.33px] leading-[17.33px] font-[400] text-[#4F4F4F] mb-2"
            >
             {t('contactus.chooselocation')}
            </label>
            <select
              id="location"
              name="location"
              className="w-full border border-[#B0B0B0] rounded-[12px] px-4 py-2"
              onChange={handleLocationChange}
              value={selectedLocation}
            >
              <option value="default">{t('contactus.chooselocation')}</option>
              <option value="Skopje">{t('contactus.loc1')}</option>
              <option value="Tabanovce">{t('contactus.loc4')}</option>
            </select>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="firstName"
                className="block text-[13.33px] leading-[17.33px] font-[400] text-[#4F4F4F] mb-2"
              >
                {t('contactus.name')}
              </label>
              <input
                id="firstName"
                name="firstName"
                type="text"
                placeholder={t('contactus.name')}
                className="w-full border border-[#B0B0B0] rounded-[12px] px-4 py-2"
                required
              />
            </div>
            <div>
              <label
                htmlFor="lastName"
                className="block text-[13.33px] leading-[17.33px] font-[400] text-[#4F4F4F] mb-2"
              >
                {t('contactus.surname')}
              </label>
              <input
                id="lastName"
                name="lastName"
                type="text"
                placeholder={t('contactus.surname')}
                className="w-full border border-[#B0B0B0] rounded-[12px] px-4 py-2"
                required
              />
            </div>
          </div>

          <div>
            <label
              htmlFor="email"
              className="block text-[13.33px] leading-[17.33px] font-[400] text-[#4F4F4F] mb-2"
            >
              {t('contactus.email')}
            </label>
            <input
              id="email"
              name="email"
              type="email"
              placeholder={t('contactus.email')}
              className="w-full border border-[#B0B0B0] rounded-[12px] px-4 py-2"
              required
            />
          </div>

          <div>
            <label
              htmlFor="phone"
              className="block text-[13.33px] leading-[17.33px] font-[400] text-[#4F4F4F] mb-2"
            >
              {t('contactus.phone')}
            </label>
            <input
              id="phone"
              name="phone"
              type="text"
              placeholder={t('contactus.phone')}
              className="w-full border border-[#B0B0B0] rounded-[12px] px-4 py-2"
              required
            />
          </div>

          <div>
            <label
              htmlFor="message"
              className="block text-[13.33px] leading-[17.33px] font-[400] text-[#4F4F4F] mb-2"
            >
              {t('contactus.message')}
            </label>
            <textarea
              id="message"
              name="message"
              placeholder={t('contactus.message')}
              rows="5"
              className="w-full border border-[#B0B0B0] rounded-[12px] px-4 py-2"
              required
            ></textarea>
          </div>

          <div>
            <button
              type="submit"
              className="w-full bg-[#FEEED6] text-[#F67E20] font-bold py-3 rounded-[12px] hover:bg-[#F67E20] hover:text-[#FEEED6] transition"
            >
              {t('contactus.submit')} <i className="fa-solid fa-paper-plane ml-2"></i>
            </button>
          </div>
        </form>
      </div>

      <div className="lg:mt-[210px] mt-0 md:justify-self-end">
        <h2 className="block text-[13.33px] leading-[17.33px] font-[400] text-[#4F4F4F] mb-2">{t('contactus.map')}</h2>
        <div className="mb-8">
          <iframe
            src={getMapSrc()}
            className="lg:w-[457px] w-full h-[457px]"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="space-y-4">
          <p className="text-[#111111] text-[400] text-[13.33px] leading-[17.33px]">
            <span>{t('footer.links.workingDays')}: 8:30 - 16:30 </span> {t('footer.links.saturday')}: 9:00 - 13:00
          </p>
          <p className="text-[#111111] text-[400] text-[13.33px] leading-[17.33px]">
            <i className="fa-solid fa-envelope mr-2 text-[#F67E20]"></i>
            <span>{t('contactus.email')}:</span> office@simax.com.mk
          </p>
          <p className="text-[#111111] text-[400] text-[13.33px] leading-[17.33px]">
            <i className="fa-solid fa-location-dot mr-2 text-[#F67E20]"></i>
            <span>{t('contactus.addresstitle')}:</span> {t('contactus.address')}
          </p>
          <p className="text-[#111111] text-[400] text-[13.33px] leading-[17.33px]">
            <i className="fa-solid fa-phone mr-2 text-[#F67E20]"></i>
            <span>{t('contactus.phone')}:</span> 02 3135017
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;

